import { createTheme } from '@mui/material/styles'
import { useEffect } from 'react'
import { Layout, LayoutProps, Sidebar, useSetLocale } from 'react-admin'
import { useSelector, useStore } from 'react-redux'
import { useLocation } from 'react-router-dom'
// import { AppState } from '~/types'
import { TwoFactorGate } from '~/pages/account/TwoFactorGate'
import { AppState } from '../types'
import AppBar from './AppBar'
import ErrorPage from './ErrorPage'
import Menu from './Menu'
import { darkTheme, lightTheme, testTheme } from './themes'

const CustomSidebar = (props: any) => <Sidebar {...props} size={200} />
const NoSideBar = () => <></>

const getTheme = (theme: String) => {
  switch (theme) {
    case 'dark':
      return darkTheme
    case 'test':
      return testTheme
    default:
      return lightTheme
  }
}

/**
 * The MUI theme the app selects from its own persisted redux state.
 *
 * react-admin 4 removed `theme` from <Layout>; it belongs on <Admin> now. That
 * is not just a rename — an unrecognised `theme` prop reaches a styled
 * component, and emotion reuses the React props object verbatim when `theme` is
 * already on it, so MUI's attachTheme then tries to mutate frozen props and
 * throws. Hence a hook, called by <App> inside the redux Provider.
 */
export const useAppTheme = () =>
  createTheme(useSelector((state: AppState) => getTheme(state.theme)))

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (props: LayoutProps) => {
  // Set locale on Mount
  const setLocale = useSetLocale()
  const store = useStore<AppState>()
  useEffect(() => {
    setLocale(store.getState().locale)
  }, [setLocale])

  const location = useLocation()
  const isGuided = location.pathname.includes('/guided')

  return (
    <Layout
      {...props}
      appBar={AppBar}
      sidebar={isGuided ? NoSideBar : CustomSidebar}
      menu={Menu}
      error={ErrorPage}
    >
      {/* Mandatory two-factor sign-in for admins, when app_settings says so. */}
      <TwoFactorGate>{props.children}</TwoFactorGate>
    </Layout>
  )
}
